import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  token: localStorage.getItem('vendispot_token') || null,
  user: JSON.parse(localStorage.getItem('vendispot_user')) || null,
  isLoggedIn: !!localStorage.getItem('vendispot_token'),
}

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    login: (state, action) => {
      state.token = action.payload.token
      state.user = action.payload.user
      state.isLoggedIn = true
      localStorage.setItem('vendispot_token', action.payload.token)
      localStorage.setItem('vendispot_user', JSON.stringify(action.payload.user))
    },
    logout: (state) => {
      state.token = null
      state.user = null
      state.isLoggedIn = false
      localStorage.removeItem('vendispot_token')
      localStorage.removeItem('vendispot_user')
    },
  },
})

export const { login, logout } = authSlice.actions

export default authSlice.reducer